import React from 'react';
import BusinessTerms from './BusinessTerms.md';
import ReactMarkdown from 'react-markdown'
import {Box} from "@mui/material";
import {Helmet} from "react-helmet";

function BusinessTermsPage(){
    return (
           <Box margin={"25px"} marginBottom={"75px"}>
               <Helmet>
                   <title>PairCare - Business Terms of Service</title>
               </Helmet>
               <Box style={{marginLeft:"auto", marginRight:"auto",  maxWidth:"750px"}}>
                    <ReactMarkdown>{BusinessTerms}</ReactMarkdown>
               </Box>
           </Box>
    );
}

export default BusinessTermsPage;
